/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Text } from "@cars24/turbo-web/lib/text";
import { stepperToRender } from "../../../constants/sell-online-constant";

const CarEvaluationStep = ({ referenceStore, appointmentDetails, stepperData, isConfirmationPage, currentStep: externalCurrentStep, isScrap = false}) => {
    const { currentStep: storeCurrentStep } = referenceStore;
    const currentStep = externalCurrentStep || storeCurrentStep;
    const { tokens } = useTokens();
    const { status: appointmentStatus } = appointmentDetails || {};
    const isCancelled = appointmentStatus === "CANCELLED" && isConfirmationPage;

    if (!stepperData?.sectionData && !stepperData?.sectionData?.length) return;

    const tabsToRender = stepperToRender(isCancelled, stepperData.sectionData, isScrap);
    const currentStepIndex = tabsToRender.findIndex(tab => tab.key === currentStep);

    const getStyles = (tab, index) => {
        if (index < currentStepIndex) {
            return "styles.done";
        } else if (index === currentStepIndex && currentStep === tab.key) {
            return "styles.current";
        }
        return "";
    };

    const getImageUrl = (tab, index) => {
        const isCurrent = index === currentStepIndex && currentStep === tab.key;
        const isDone = index < currentStepIndex;

        if (isCurrent) {
            return tab.activeImage;
        } else if (isDone) {
            return tab.inActiveImage;
        } else {
            return tab.upcomingImage || tab.inActiveImage;
        }
    };

    return (
        <React.Fragment>
            <ul styleName={"styles.stepperWrap"}>
                {tabsToRender.map((tab, index) => {
                    return (
                        <li styleName={getStyles(tab, index)} key={index}>
                            <img
                                src={getImageUrl(tab, index)}
                                alt="step icon"
                                style={{
                                    width: 40,
                                    height: 40,
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    zIndex: 99
                                }}
                            />
                            <a>
                                <Text
                                    align="left"
                                    as="p"
                                    color={tokens.text_default_text_primary}
                                    fontWeight="semibold"
                                    size="250"
                                    transform="none"
                                >
                                    {tab.heading}
                                </Text>
                                <Text
                                    align="left"
                                    as="p"
                                    color={tokens.text_default_text_secondary}
                                    fontWeight="regular"
                                    size="200"
                                    transform="none"
                                >
                                    {tab.subHeading}
                                </Text>
                            </a>
                        </li>
                    );
                })}
            </ul>
        </React.Fragment>
    );
};

CarEvaluationStep.propTypes = {
    referenceStore: PropTypes.object,
    appointmentDetails: PropTypes.object,
    stepperData: PropTypes.object,
    isConfirmationPage: PropTypes.bool,
    currentStep: PropTypes.string,
    isScrap: PropTypes.bool
};

export default withRouter(CarEvaluationStep);
